import React, { SVGProps } from 'react';
import '../icon-style.css';

const SvgCustomSettings = (props: SVGProps<SVGSVGElement>) => (
    

        <svg width="30" height="30"  xmlSpace='preserve' viewBox="0 0 30 30" fill="none" className='svg-icon'  xmlns="http://www.w3.org/2000/svg">
        <g id="GearSix" clip-path="url(#clip0_89_6950)" >
        <path id="Vector" d="M15 19.6875C17.5888 19.6875 19.6875 17.5888 19.6875 15C19.6875 12.4112 17.5888 10.3125 15 10.3125C12.4112 10.3125 10.3125 12.4112 10.3125 15C10.3125 17.5888 12.4112 19.6875 15 19.6875Z" stroke="#E8EAED" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_2" d="M15.2421 24.1535C15.0851 24.1535 14.9269 24.1535 14.7734 24.1535L11.0175 26.25C9.55538 25.7582 8.19923 24.9948 7.02024 24L7.00617 19.7813C6.92297 19.65 6.84446 19.5176 6.7718 19.3816L3.03703 17.2547C2.74286 15.7667 2.74286 14.2356 3.03703 12.7477L6.76828 10.6266C6.84446 10.4918 6.92297 10.3582 7.00266 10.227L7.02141 6.0082C8.19934 5.01052 9.55514 4.24435 11.0175 3.75L14.7675 5.84648C14.9245 5.84648 15.0827 5.84648 15.2363 5.84648L18.9863 3.75C20.4484 4.24182 21.8045 5.00518 22.9835 6L22.9976 10.2187C23.0808 10.35 23.1593 10.4824 23.232 10.6184L26.9644 12.7441C27.2585 14.2321 27.2585 15.7632 26.9644 17.2512L23.2331 19.3723C23.157 19.507 23.0784 19.6406 22.9988 19.7719L22.98 23.9906C21.8029 24.9885 20.4479 25.755 18.9863 26.25L15.2421 24.1535Z" stroke="#E8EAED" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_89_6950">
        <rect width="30" height="30" fill="white"/>
        </clipPath>
        </defs>
        </svg>

);

export default SvgCustomSettings;